import React, { Component } from 'react'
import styles from '../../assets/styles/components/WechatPayConfirmation'
import injectSheet from 'react-jss'
import BackdropLoading from './DirectoryPage/BackdropLoading'
import orderApi from 'services/api/order'
import URLParser from 'helpers/urlParser'
import {
  loadState,
  saveState,
  setStorage,
  getStorage,
} from '../../store/localStorage'
import _ from 'lodash'
class WechatPayConfirmation extends Component {
  constructor (props) {
    super(props)
    this.state = {}
  }

  componentDidMount = async () => {
    const { history } = this.props
    const urlParser = new URLParser(window.location.href)
    const params = urlParser.getParams()
    const token = loadState().user.token
    const { cid: cacheId, isDineIn } = params
    if (!cacheId) {
      console.error('!cache')
      // history.push("/")
      return
    }
    setInterval(async () => {
      try {
        const cache = await orderApi.loadCache(cacheId, token)
        if (_.isEmpty(cache)) {
          console.error('!cache')
          // history.push("/")
          return
        }
        const { state, wc_payload: wcPayload } = cache
        saveState(state)
        setStorage('wc_payload', wcPayload)

        if (isDineIn) {
          const order = await this.getWechatOrderStatus(state.basket.id)
          if (order) {
            history.push('/basket/checkout_complete')
          }
        } else {
          history.push('/basket/takeaway_summary')
        }
      } catch (error) {
        console.log(error)
      }
    }, 3000)
  }

  getWechatOrderStatus = async (id) => {
    const { out_trade_no, syssn } = getStorage('wc_payload')

    if (!out_trade_no) {
      return
    }
    await orderApi.getWechatOrderStatus(out_trade_no).then(async (res) => {
      //  TODO: how to define success response
      if (res.respcd === '0000') {
        await this.props.submitDineinPayment(id, {
          payment: {
            paymentMethod: 'wechatpay',
          },
          out_trade_no: out_trade_no,
          syssn,
          source: out_trade_no,
        })

        return true
      } else {
        return false
      }
    })
  }

  render () {
    return (
      <React.Fragment>
        <BackdropLoading open={true} />
      </React.Fragment>
    )
  }
}

export default injectSheet(styles)(WechatPayConfirmation)



// WEBPACK FOOTER //
// ./src/components/scenes/WechatPayConfirmation.js